module.exports = __webpack_public_path__ + "img/wechat-earth.ea6ed898.png";